import { Breakpoints as t } from "../../style/base/index.js";
import { RocheUISlideAnimation as s, RocheUISlideTransition as l } from "./roche-slider.types.js";
const d = (e) => e <= 2 ? 1 : 2, o = {
  [t.SMALL]: 25,
  [t.MEDIUM]: 24,
  [t.LARGE]: 30,
  [t.X_LARGE]: 0,
  // unused, 0 is library default
  [t.XX_LARGE]: 0
  // unused, 0 is library default
}, u = {
  [s.ENTER_FROM_RIGHT]: 500,
  [s.CROSSFADE]: 800
}, E = {
  [s.ENTER_FROM_RIGHT]: "slide",
  [s.CROSSFADE]: "fade"
}, R = (e, i, r) => {
  const n = i === s.CROSSFADE, a = n ? 1 : d(e), c = n ? 1 : e;
  return {
    [t.SMALL]: {
      spaceBetween: o[t.SMALL],
      slidesPerView: 1,
      slidesPerGroup: 1
    },
    [t.MEDIUM]: {
      spaceBetween: o[t.MEDIUM],
      slidesPerView: a,
      slidesPerGroup: r === l.BY_PAGE ? a : 1
    },
    [t.LARGE]: {
      spaceBetween: o[t.LARGE],
      slidesPerView: c,
      slidesPerGroup: r === l.BY_PAGE ? c : 1
    }
  };
}, A = 5, S = 1e3, m = (e, i = A) => e ? {
  delay: (Number.isFinite(i) && i > 0 ? i : A) * S,
  // The pause button is the off switch; an arrow click should not end autoplay for good.
  disableOnInteraction: !1,
  // Swiper would bind this to the whole container; the slider binds it to the track instead.
  pauseOnMouseEnter: !1
} : !1, L = (e) => {
  const { loop: i, slidesPerGroup: r } = e.params;
  return i ? r && r > 1 ? Math.floor(e.realIndex / r) : e.realIndex : e.snapIndex;
}, I = (e) => u[e], M = (e) => E[e], G = (e) => {
  const i = e.el.querySelectorAll(".swiper-slide-visible"), r = Array.from(i);
  e.slides.forEach((n) => {
    r.includes(n) ? (n.removeAttribute("inert"), n.removeAttribute("aria-hidden")) : (n.setAttribute("inert", ""), n.setAttribute("aria-hidden", "true"));
  });
};
export {
  A as DEFAULT_AUTOPLAY_INTERVAL_SECONDS,
  I as getAnimationSpeedForAnimationType,
  m as getAutoplayConfig,
  L as getCurrentPageIndex,
  M as getEffectForAnimationType,
  d as getSlidesPerViewForMediumBreakpoint,
  R as rocheUISliderBreakpoints,
  G as toggleSlidesAccessibilityVisibility
};
